import axios from 'axios'
import store from '@/store'

axios.defaults.timeout = 60 * 2 * 1000

// const apiBaseUrl = process.env.NODE_ENV === 'production' ? 'http://192.168.20.30:16188/infosvronlineandapplet' : '/infosvronlineandapplet'
const apiBaseUrl = process.env.NODE_ENV === 'production' ? '/infosvronlineandapplet' : '/infosvronlineandapplet'

// json对象中的null转换为""
function null2str(data) {
  for (let x in data) {
    if (data[x] === null) {
      // 如果是null 把直接内容转为 ''
      data[x] = ''
    } else {
      if (Array.isArray(data[x])) {
        // 是数组遍历数组 递归继续处理
        data[x] = data[x].map(z => {
          return null2str(z)
        })
      }
      if (typeof data[x] === 'object') {
        // 是json 递归继续处理
        data[x] = null2str(data[x])
      }
    }
  }
  return data
}

export default class HttpRequset {
  constructor(baseUrl = apiBaseUrl) {
    this.baseUrl = baseUrl
    this.loadingCount = 0 //解决并发请求 loading被其他请求关闭问题，
  }

  showLoading() {
    store.state.showLoading = true
    this.loadingCount++
    // console.log('showLoading', this.loadingCount)
  }
  hideLoading() {
    this.loadingCount--
    // console.log('hideLoading', this.loadingCount)
    if (this.loadingCount <= 0) {
      store.state.showLoading = false
      this.loadingCount = 0
    }
  }

  /**
   * @description:
   * @param {
   *  silence:控制loading,toast显示 true 隐藏，默认 false
   *  unauthorized:控制token添加到头部 true 不添加token,默认 false
   * } options
   * @return {*}
   */
  request(options) {
    const instance = axios.create()
    options = this._mergeConfig(options)
    this._interceptors(instance, options)
    return instance(options)
  }
  /**
   * @description:
   * @param {*} url
   * @param {*} data
   * @param {
   *  silence:控制loading,toast显示 true 隐藏，默认 false
   *  unauthorized:控制token添加到头部 true 不添加token,默认 false
   * } config
   * @return {*}
   */
  post(url, data, config) {
    const instance = axios.create()
    let options = {
      data,
      method: 'POST',
      url,
      ...config
    }
    options = this._mergeConfig(options)
    this._interceptors(instance, options)
    return instance(options)
  }
  /**
   * @description:
   * @param {*} url
   * @param { * } params
   * @param {
   *  silence:控制loading,toast显示 true 隐藏，默认 false
   *  unauthorized:控制token添加到头部 true 不添加token,默认 false
   * } config
   * @return {*}
   */
  get(url, params, config) {
    const instance = axios.create()
    const mParams = params && Reflect.has(params, 'params') ? params : {params}
    let options = {
      ...mParams,
      method: 'GET',
      url,
      ...config
    }
    options = this._mergeConfig(options)
    this._interceptors(instance, options)
    return instance(options)
  }
  put(url, data, config) {
    const instance = axios.create()
    let options = {
      data,
      method: 'PUT',
      url,
      ...config
    }
    options = this._mergeConfig(options)
    this._interceptors(instance, options)
    return instance(options)
  }
  delete(url, data, config) {
    const instance = axios.create()
    let options = {
      data,
      method: 'DELETE',
      url,
      ...config
    }
    options = this._mergeConfig(options)
    this._interceptors(instance, options)
    return instance(options)
  }

  _interceptors(instance, options) {
    // 在这里添加请求和响应拦截
    // debugger
    instance.interceptors.request.use(
      config => {
        // this._requsetFilter(options, config)
        // config.headers['Access-Token'] = store.state.userInfo
        //   ? store.state.userInfo.token
        //   : ''
        config.headers['Access-Token'] = store.state.token || localStorage.getItem('Token')
        // console.log('config-----', config)
        console.log('token-----', config.headers['Access-Token'])
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
    instance.interceptors.response.use(
      response => {
        //   const res = response.data
        if (response == undefined) {
          return Promise.resolve()
        }
        return this._responseFilter(response)
      },
      error => {
        // console.log('_interceptors error', error.response.data)
        return Promise.reject(error) //最终是成功还是失败，内部处理判断
      }
    )
  }

  _mergeConfig(options) {
    return Object.assign(
      {
        baseURL: this.baseUrl
      },
      options
    )
  }
  _responseFilter(response) {
    let res = null2str(response.data)
    if (res.columns == undefined || res.hideColumns == undefined) {
      return res
    }
    let arr = res['columns'].filter(
      item => !res['hideColumns'].includes(item.key)
    )
    res.columns = arr
    return res
  }
}
window.axios = new HttpRequset()
